// QuickActions.tsx
import React from 'react';
import { Send, BookmarkPlus, MapPinned, Layers } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const ACTIONS = [
  { 
    label: 'RFQ', 
    icon: Send, 
    grad: 'from-blue-500 to-indigo-500', 
    glow: 'rgba(59,130,246,0.45)',
    path: '/rfq'
  },
  { 
    label: 'New Booking', 
    icon: BookmarkPlus, 
    grad: 'from-emerald-500 to-teal-500', 
    glow: 'rgba(16,185,129,0.45)',
    path: '/import-booking/new'
  },
  { 
    label: 'Track Shipment', 
    icon: MapPinned, 
    grad: 'from-violet-500 to-purple-600', 
    glow: 'rgba(139,92,246,0.45)',
    path: '/ai-agent-dashboard'
  },
  { 
    label: 'Rate Matrix', 
    icon: Layers, 
    grad: 'from-amber-500 to-orange-500', 
    glow: 'rgba(245,158,11,0.45)',
    path: '/ratematrix'
  },
];

export function QuickActions() {
  const navigate = useNavigate();

  return (
    <motion.section 
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.7 }}
      className="rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden"
      data-testid="quick-actions"
    >
      <div className="px-5 py-4 border-b border-slate-100 dark:border-slate-800">
        <div className="text-[14px] font-semibold text-slate-900 dark:text-white">Quick Actions</div>
      </div>
      <div className="p-5 grid grid-cols-2 gap-3">
        {ACTIONS.map((a, idx) => {
          const I = a.icon;
          return (
            <motion.button
              key={a.label}
              onClick={() => navigate(a.path)}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.1 * idx }}
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.98 }}
              className="group relative overflow-hidden rounded-xl p-5 text-left
                         border border-slate-200 dark:border-slate-700 
                         bg-white dark:bg-slate-900
                         hover:-translate-y-0.5 transition-all duration-200
                         hover:shadow-xl"
              style={{ boxShadow: `0 6px 18px -10px ${a.glow}` }}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${a.grad} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${a.grad} text-white
                               flex items-center justify-center mx-auto
                               shadow-[0_8px_18px_-6px_rgba(0,0,0,0.25)]
                               group-hover:scale-110 transition-transform duration-200`}>
                <I className="w-5 h-5" />
              </div>
              <div className="mt-3 text-center text-[13px] font-semibold text-slate-900 dark:text-white">{a.label}</div>
            </motion.button>
          );
        })}
      </div>
    </motion.section>
  );
}

export default QuickActions;